"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonStyle = void 0;
var react_native_1 = require("react-native");
var styles = {
    bgWhite: {
        backgroundColor: '#ffffff',
    },
    bold: {
        fontWeight: 'bold',
    },
    colorWhite: {
        color: '#ffffff',
    },
    middle: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    flex1: {
        flex: 1,
    },
    absolute: {
        position: 'absolute',
    },
    absoluteFill: __assign({}, react_native_1.StyleSheet.absoluteFillObject),
    shadow: {
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.20,
        shadowRadius: 1.41,
        elevation: 2,
    },
    width100p: {
        width: '100%',
    },
    height100p: {
        height: '100%',
    },
    overflowH: {
        overflow: 'hidden'
    }
};
exports.commonStyle = react_native_1.Platform.OS === 'web' ? styles : react_native_1.StyleSheet.create(__assign({}, styles));
//# sourceMappingURL=commonStyle.js.map